
import { getPageStructureFromTree } from "@/lib/singularity/page-structure/page-structure";
import { documentStore, singularityStore } from "@/store/store";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import PageStructureSection from "./PageStructureSection.vue";
import draggable from "vuedraggable";
import { PageSection } from "@/lib/singularity/page-structure/page-structure";
import PanelHeader from "@/components/Reusable/Util/PanelHeader.vue";
import Dropdown from "@/components/Reusable/Dropdown/Dropdown.vue";
import IconButton from "@/components/UI/IconButton.vue";

@Component({
  components: {
    PageStructureSection,
    draggable,
    PanelHeader,
    Dropdown,
    IconButton
  }
})
export default class PageStructure extends Vue {
  get structure() {
    return getPageStructureFromTree(documentStore.document.tree);
  }

  get pageTitle() {
    return documentStore.document.documentMeta.titleLabel;
  }

  handleChange(
    // https://github.com/SortableJS/Vue.Draggable#events
    event: {
      moved?: { newIndex: number; oldIndex: number; element: PageSection };
    }
  ) {
    if (event.moved) {
      const treeNodeIdToMove = event.moved.element.nodeId;
      const newIndex = event.moved.newIndex;
      documentStore.moveElement({
        draggedElementId: treeNodeIdToMove,
        droppedOnElementId: documentStore.document.tree.root.id,
        index: newIndex
      });
    }
  }

  addSection() {
    singularityStore.setSectionAddOrSwapPanelState({
      mode: "add",
      sectionIdToAddAfterOrSwap: this.structure.length
        ? this.structure[this.structure.length - 1].nodeId
        : null
    });
    singularityStore.setSingularityLeftPanel("section_add_or_swap");
  }

  clearStructure() {
    documentStore.document.tree.root.children
      .map(child => {
        return child.id;
      })
      .forEach(id => {
        documentStore.deleteElement({ nodeId: id });
      });
  }

  close() {
    alert("close");
  }
}
